<template>
    <div class="custom_checkbox tw-relative tw-bg-white">
        <input type="checkbox"
               :id="id"
               :name="name"
               :value="initialValue"
               style="margin-top: 0;"
               class="tw-opacity-0 tw-absolute tw-top-0 tw-left-0 tw-w-4 tw-h-4"
               :class="classes"
               v-model="checked"
               @change="onChange"
        >
        <div class="tw-w-4 tw-h-4 tw-border tw-border-brand-info tw-rounded tw-text-white ">
            <svg class="" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"></path>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {},
            id: {
                required: true,
                type: String,
            },
            name: {
                required: true,
                type: String,
            },
            initialValue: {
                required: false,
                default: '',
            },
            classes: {
                required: false,
                type: String,
                default: '',
            }
        },
        data() {
            return {
                checkedProxy: false
            }
        },
        computed: {
            checked: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.checkedProxy = val;
                }
            }
        },
        methods: {
            onChange: function (e) {
                this.$emit('input', this.checkedProxy)
            }
        }
    }
</script>